import Container from "Components/Container/Container";
import CategoryTabs from "../../../../CategoryTabs/CategoryTabs";

const Landing = ({ data, title }) => {
  return (
    <section>
      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-x-10 pb-primary lg:-mt-[20vh]">
          <div className="col-span-1">
            <div className="sticky top-[10vh]">
              <CategoryTabs
                selectedCategory="trainings-and-workshops"
                isInner={true}
              />
            </div>
          </div>
          <div className="col-span-3">
            <h2 className="text-white bebas text-4xl tracking-[1.4px] mb-6">
              {title}
            </h2>
            <div
              className="text-white text-lg"
              dangerouslySetInnerHTML={{ __html: data }}
            />

            <a
              target="_blank"
              href="https://lnkd.in/e6uNzahs"
              className="block uppercase  text-white transition ease-in duration-300 bg-[#333] p-3 hover:bg-[#555] mt-10 text-center text-lg"
              rel="noreferrer"
            >
              Reserve your spot
            </a>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Landing;
